import { useState, useEffect } from 'react';

export default function CountdownSection() {
  // Calculer le prochain jeudi à 23h59
  const getNextThursday = () => {
    const now = new Date();
    const daysUntilThursday = (4 - now.getDay() + 7) % 7;
    const nextThursday = new Date(now);
    
    if (daysUntilThursday === 0 && now.getHours() >= 23 && now.getMinutes() >= 59) {
      // Si on est jeudi après 23h59, aller au jeudi suivant
      nextThursday.setDate(now.getDate() + 7);
    } else if (daysUntilThursday === 0) {
      // Si on est jeudi avant 23h59
      nextThursday.setDate(now.getDate());
    } else {
      // Sinon aller au prochain jeudi
      nextThursday.setDate(now.getDate() + daysUntilThursday);
    }
    
    nextThursday.setHours(23, 59, 0, 0);
    return nextThursday.getTime();
  };

  const targetDate = getNextThursday();
  
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <section className="py-16 bg-gradient-to-br from-[#3D2817] to-[#2C1810] relative overflow-hidden">
      {/* Motif de fond */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#E8956F]/20 px-4 py-2 rounded-full mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-alarm-warning-line text-[#E8956F] text-base"></i>
            </div>
            <span className="text-sm font-medium text-[#E8956F]">Offre à durée limitée</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            La formation débute le 22 décembre
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            4 semaines pour transformer votre pratique équestre et reprendre votre liberté à cheval
          </p>
        </div>

        {/* Compte à rebours */}
        <div className="grid grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto mb-12">
          {[
            { value: timeLeft.days, label: 'Jours' },
            { value: timeLeft.hours, label: 'Heures' },
            { value: timeLeft.minutes, label: 'Minutes' },
            { value: timeLeft.seconds, label: 'Secondes' }
          ].map((item, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/20">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {String(item.value).padStart(2, '0')}
              </div>
              <div className="text-sm text-white/70 font-medium">{item.label}</div>
            </div>
          ))}
        </div>

        {/* Preuves sociales */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8">
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-user-heart-line text-[#E8956F] text-lg"></i>
            </div>
            <span className="text-white font-medium">Déjà 10 cavalières inscrites</span>
          </div>
          
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-fire-line text-[#E8956F] text-lg"></i>
            </div>
            <span className="text-white font-medium">Plus que 05 places disponibles</span>
          </div>
        </div>

        {/* CTA principal */}
        <div className="text-center">
          <a 
            href="https://sophrocavaliers.learnybox.com/formation-endometriose-cavalieres/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-[#E8956F] text-white rounded-full text-lg font-semibold hover:bg-[#D67D5A] transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span>Réserver ma place maintenant</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </a>
          <p className="text-white/60 text-sm mt-4">🔒 Paiement sécurisé • Ouverture de la formation le 22 décembre</p>
        </div>
      </div>
    </section>
  );
}